import { useState } from "react";
import { Trans } from "@lingui/macro";
import { Card, CardContent } from "@/components/ui/card";
import { AuthShell } from "./AuthShell";
import { AUTH_CARD_MIN_H } from "./WelcomePage";
import { CustomSignInForm, type SignInStep } from "./CustomSignInForm";

export function SignInPage() {
  const [step, setStep] = useState<SignInStep>("email");
  const [email, setEmail] = useState("");

  return (
    <AuthShell>
      <Card className="w-full max-w-md rounded-2xl shadow-sm">
        <CardContent
          className={`flex flex-col items-center text-center px-8 pt-12 pb-12 ${AUTH_CARD_MIN_H}`}
        >
          <div className="flex flex-col items-center gap-4">
            <img
              src="/favicon-512.png"
              alt="Daycare Butler"
              className="h-24 w-24 rounded-2xl"
              width={96}
              height={96}
            />
            <h1 className="text-xl font-semibold">Daycare Butler</h1>
            <h2 className="text-2xl font-bold mt-2">
              {step === "email" ? (
                <Trans id="auth.signIn.title">Sign in</Trans>
              ) : step === "reset" ? (
                <Trans id="auth.signIn.resetTitle">Reset your password</Trans>
              ) : (
                <Trans id="auth.signIn.passwordTitle">Enter your password</Trans>
              )}
            </h2>
            <p className="text-sm text-muted-foreground break-all">
              {step === "email" ? (
                <Trans id="auth.signIn.subtitle">Welcome back</Trans>
              ) : (
                email
              )}
            </p>
          </div>
          <div className="w-full flex-1 flex flex-col mt-6 text-left">
            <CustomSignInForm
              step={step}
              email={email}
              onEmailChange={setEmail}
              onStepChange={setStep}
            />
          </div>
        </CardContent>
      </Card>
    </AuthShell>
  );
}
